import React from 'react';
import OrderCapacityForm from '../../components/OrderCapacity/OrderCapacityForm';
import { useParams } from 'react-router-dom';

const OrderCapacityPage: React.FC = () => {
    const { orderFileId } = useParams<{ orderFileId: string }>();
    return <OrderCapacityForm orderFileId={Number(orderFileId)} />;
};

export default OrderCapacityPage; 